module.exports = __webpack_public_path__ + "img/n04.ff23064e.png";